import * as React from 'react';
import type { Product } from '@/types';

export interface StoreLogoProps {
  product: Product;
}

export function StoreLogo({ product }: StoreLogoProps) {
  const spacesBaseUrl = 'https://shoppyapp.syd1.digitaloceanspaces.com';
  const logoUrl = `${spacesBaseUrl}/${product.storeId}.png`;

  return (
    <img
      src={logoUrl}
      alt={`${product.storeId} logo`}
      className="w-8 h-auto"
    />
  );
}
